import Constants from 'expo-constants';

// App Constants
export const CONSTANTS = {
  // Google Maps API Key
  GOOGLE_MAPS_API_KEY: Constants.expoConfig?.extra?.GOOGLE_MAPS_API_KEY ?? '',
  
  // Map Configuration
  MAP_CONFIG: {
    DEFAULT_ZOOM: 15,
    DEFAULT_LOCATION: {
      lat: 40.7282,
      lng: -73.7949, // Queens, NY
    },
    MAP_SIZE: {
      width: 400,
      height: 200,
    },
  },
} as const;